import { useCallback } from "react";

import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../../base/use-case/use-create-model/use-create-model";
import type { SiteControllerSettingNeppanFormModel } from "../../../type";

type Props = {
	viewModel: SiteControllerSettingNeppanFormModel["ViewModel"];
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
};

export type SiteControllerSettingNeppanFormModelMethodsType = {
	siteControllerSettingNeppanFormModelMethods: {
		onSetPassword: (value: string) => void;
		onSetSetUpRoomPriceByChillnn: (value: boolean) => void;
	};
};

type UseSiteControllerSettingNeppanFormModelMethodsType = ({
	viewModel,
	onSetViewModel,
}: Props) => SiteControllerSettingNeppanFormModelMethodsType;

export const useSiteControllerSettingNeppanFormModelMethods: UseSiteControllerSettingNeppanFormModelMethodsType = ({
	onSetViewModel,
}) => {
	const onSetPassword = useCallback(
		(value: string) => {
			onSetViewModel([
				{
					key: "password",
					value: {
						isEdited: true,
						value,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	const onSetSetUpRoomPriceByChillnn = useCallback(
		(value: boolean) => {
			onSetViewModel([
				{
					key: "setUpRoomPriceByChillnn",
					value: {
						isEdited: true,
						value,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return {
		siteControllerSettingNeppanFormModelMethods: {
			onSetPassword, //
			onSetSetUpRoomPriceByChillnn,
		},
	};
};
